// pageHeaderMobile component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import _ from 'lodash'
import ReactDom from 'react-dom'

import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import ScrollableContent from '../scrollable_content/scrollable_content.jsx'

class PageHeaderMobile extends Component {
  constructor (props) {
    super(props)

    this.state = {
      timeTaken: 0
    }

    this.bAnimate = true
    this._references = {}

    const currDate = DateUtil.getUTCCurrentDate()
    this.curDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    )
  }

  static get propTypes () {
    return {
      stat: PropTypes.object,
      onClickDay: PropTypes.func,
      onClickToday: PropTypes.func,
      onPaginate: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      stat: null,
      onClickDay: null,
      onClickToday: null,
      onPaginate: null
    }
  }

  render () {
    if (!this.props.stat || !this.props.stat.days) {
      return null
    }

    const activeIdx = _.findIndex(this.props.stat.days, (obj) =>
      DateUtil.isDateEqual(new Date(obj.date), this.curDate)
    )
    const winWidth = $(window).outerWidth()
    const itemWidth = 130
    const itemLeftCount = winWidth / itemWidth / 2

    const wrapStyle = {
      minWidth: `${(this.props.stat.days.length + 1) * itemWidth}px`
    }

    return (
      <div className='page-headermobile'>
        <ScrollableContent
          className={`days${this.bAnimate ? ' animate' : ''}`}
          style={wrapStyle}
          positionLeft={(activeIdx - itemLeftCount.toFixed(0)) * itemWidth}
          activeDate={this.curDate}
          activeIndex={activeIdx}
          startDate={new Date(this.props.stat.days[0].date)}
          onReachLeft={this._onPaginate.bind(this, false)}
          onReachRight={this._onPaginate.bind(this, true)}
          getPositionLeftByDate={this._getPositionLeftByDate.bind(this)}
        >
          {this._renderDays()}
        </ScrollableContent>
        <IconButton
          size='big'
          icon='time-reload'
          title='user.signup.submit'
          className='mobileheaderbutton'
          canHover
          onClick={this._onClickToday.bind(this)}
        />
      </div>
    )
  }

  /* Private Functions */
  _renderDays () {
    const { stat } = this.props
    const days = stat ? stat.days : []

    if (days && days.length === 0) {
      return null
    }

    const currDate = this.curDate
    return days.map((day, _idx) => {
      const dayDateUTC = new Date(day.date)
      const className = `dayitem${
        DateUtil.isDateEqual(dayDateUTC, currDate) ? ' active' : ''
      }`

      return (
        <div
          className={className}
          key={dayDateUTC.getTime()}
          style={this.state.itemStyle}
          ref={this._getItemRef(`day_${dayDateUTC.getTime()}`, true)}
          onClick={this._onClickDay.bind(this, dayDateUTC, day.timeTaken)}
        >
          <span className='title'>{DateUtil.getDisplayWeekDay(day.date)}</span>
          {day.bshowTime ? (
            <span className='label'>
              {day.timeTaken > 0
                ? Util.convertMinutesToTimeText(day.timeTaken)
                : '0 Hours'}
            </span>
          ) : (
            <span className='label'>
              {DateUtil.getDisplayDayMonth(day.date)}
            </span>
          )}
        </div>
      )
    })
  }

  _onClickDay (date, timeTaken, _ev) {
    this.bAnimate = true
    this.curDate = date

    if (this.props.onClickDay) {
      if (this._animationTimer) window.clearTimeout(this._animationTimer)

      this._animationTimer = window.setTimeout(() => {
        this.bAnimate = false
        this.props.onClickDay(date, timeTaken)
      }, 500)
    }

    this.setState({ dataDate: new Date(), timeTaken: timeTaken })
  }

  _onClickToday () {
    const currDate = DateUtil.getUTCCurrentDate()
    this.curDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    )
    const activeTimeTaken = _.find(
      this.props.stat.days,
      (day) => new Date(day.date).getDate() === this.curDate.getDate()
    )

    if (this.props.onClickDay) {
      this.props.onClickDay(this.curDate, activeTimeTaken.timeTaken)
    }

    this.setState({ dataDate: new Date() })
  }

  _onPaginate (bFuture) {
    if (this.props.onPaginate) {
      this.props.onPaginate(bFuture)
    }
  }

  _getPositionLeftByDate (date) {
    let scrollLeft = null
    const dayDateUTC = new Date(date)
    const itemRef = this._getItemRef(`day_${dayDateUTC.getTime()}`, false)
    if (itemRef && itemRef.current) {
      const node = ReactDom.findDOMNode(itemRef.current)
      if (node) {
        scrollLeft = node.getBoundingClientRect().left
      }
    }

    return scrollLeft
  }

  _getItemRef (ident, bCreate) {
    let itemRef = this._references[ident]
    if (bCreate && !itemRef) {
      itemRef = React.createRef()
      this._references[ident] = itemRef
    }

    return itemRef
  }
}

export default PageHeaderMobile
